<template>
  <v-card class="rounded-lg pa-2 pb-5 white" flat>
    <v-card-title class="secondary--text"> نمودار هزینه ها
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="cost-chart"></chart-export-btn>

    </v-card-title>
    <canvas height="120" id="cost-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'CostChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "مبلغ",
              data: [],
              backgroundColor: "#F1416C",
              borderColor: "#F1416C",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
          ]
        },

        options: {
          indexAxis: 'y',
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          scales: {
            xAxes: [{
              display: true,
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                padding: 15,
                callback: function(value, index, values) {
                  if (
                      value.length > 25
                  ) {
                    return value.substr(0, 25) + "...";
                  }
                  else {
                    return  value
                  }

                }

              }

            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .12)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }

                }
              }
            ]
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },
        }
      }
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/costsChartReportApi`),
        method: "get",
        success: data => {
          this.setData(data)
        }
      })
    },

    setData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let acc of data){
        this.chartData.data.labels.push(acc.title)
        this.chartData.data.datasets[0].data.push(acc.amount)

      }

      this.setChart()
    },
    setChart(){
      const ctx = document.getElementById('cost-chart');
      new Chart(ctx, this.chartData);
    },
  },

  mounted() {
    this.getChartFromApi()
  }

}
</script>